import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import MoodBoosterCollection from 'collections/mood_booster';
import YoursVsCommunityView from 'views/yours_vs_community';
import ActivityView from 'views/activity';


export default YoursVsCommunityView.extend({
  initialize: function (options) {
    _.bindAll(this, 'render');

    this.setup_collapsers();

    // Templates
    this.mood_booster = _.template($('#mood-booster-template').html());

    // Page elements
    this.your_elevating_activities = $('#your-elevating-activities');
    this.community_elevating_activities = $('#community-elevating-activities');

    this.options = options;
    // Collections
    this.mood_booster_collection = options.parent_view.mood_booster_collection;
  },

  render: function () {
    var yours = this.mood_booster_collection.where({ isPersonal: true });
    var comm = this.mood_booster_collection.where({ isPersonal: false });
    var panels = [
      { collection: comm, el: this.community_elevating_activities }
    ];
    if (!this.your_elevating_activities.is('.default')) {
      panels.push({ collection: yours, el: this.your_elevating_activities });
    }

    // Populate mood booster lists
    var self = this;
    _.each(panels, function (panel) {
      // For now, insert a blank li when the collection is empty,
      // otherwise the collapser doesn't work!
      panel.el.html(!panel.collection.length ? '<li></li>' : '');
      _.each(_.last(panel.collection, 5), function (booster) {
        var activity = self.collection.findWhere({
          resource_uri: booster.get('activity')
        });
        if (activity) {
          var mood_booster = self.mood_booster_collection.findWhere({
            activity: activity.get('resource_uri'), isTop: true });
          panel.el.prepend(self.mood_booster({
            activity: activity, booster: booster,
            mood_booster: mood_booster
          }));
        }
      });
      // Enable star tooltips
      $('.mood-booster.starred', panel.el).tooltip();
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/views/mood_boosters.js